import { buildGlyphAtlas, filterGlyphAtlas } from './atlas.js';
import { CHARSET_PRINTABLE_ASCII } from './constants.js';
import { RAW_GLYPHS as RAW_GLYPHS_BLACK_TEXT_RGB } from './generated/glyph_atlas_black_on_white_rgb.js';
import { RAW_GLYPHS as RAW_GLYPHS_BLACK_TEXT_BGR } from './generated/glyph_atlas_black_on_white_bgr.js';
import { RAW_GLYPHS as RAW_GLYPHS_CLEARTYPE_RGB_BOLD } from './generated/glyph_atlas_cleartype_rgb_bold.js';
import { RAW_GLYPHS as RAW_GLYPHS_CLEARTYPE_BGR_BOLD } from './generated/glyph_atlas_cleartype_bgr_bold.js';
const atlasCache = new Map();
const boldAtlasCache = new Map();
/** Characters currently covered by the generated bold atlases, in tie-break order. */
const RAW_BOLD_CHARS = new Set(RAW_GLYPHS_CLEARTYPE_RGB_BOLD.map((glyph) => glyph.char));
export const CHARSET_CLEARTYPE_RGB_BOLD = [...CHARSET_PRINTABLE_ASCII]
    .filter((char) => RAW_BOLD_CHARS.has(char))
    .join('');
/** Return the production black-text-on-white regular-font glyph atlas. */
export function getDefaultGlyphAtlas(options = {}) {
    const variant = options.variant ?? 'cleartype-rgb';
    const charset = options.charset ?? CHARSET_PRINTABLE_ASCII;
    const key = `${variant}\0${charset}`;
    const cached = atlasCache.get(key);
    if (cached)
        return cached;
    const raw = variant === 'cleartype-bgr'
        ? RAW_GLYPHS_BLACK_TEXT_BGR
        : RAW_GLYPHS_BLACK_TEXT_RGB;
    const atlas = buildGlyphAtlas(raw, { charset });
    atlasCache.set(key, atlas);
    return atlas;
}
/** Explicit alias for the production regular atlas. */
export function getBlackTextGlyphAtlas(options = {}) {
    return getDefaultGlyphAtlas(options);
}
export function narrowDefaultGlyphAtlas(atlas, charset) {
    return filterGlyphAtlas(atlas, charset);
}
/** Return the generated RGB or BGR Owl item-name bold atlas.
 *
 * The bold font is a separate font face with different advances and templates;
 * it must not be mixed with the regular small-font atlas.
 */
export function getBoldGlyphAtlas(options = {}) {
    const variant = options.variant ?? 'cleartype-rgb';
    const charset = options.charset ?? CHARSET_CLEARTYPE_RGB_BOLD;
    const key = `${variant}\0${charset}`;
    const cached = boldAtlasCache.get(key);
    if (cached)
        return cached;
    const raw = variant === 'cleartype-bgr'
        ? RAW_GLYPHS_CLEARTYPE_BGR_BOLD
        : RAW_GLYPHS_CLEARTYPE_RGB_BOLD;
    const atlas = buildGlyphAtlas(raw, { charset });
    boldAtlasCache.set(key, atlas);
    return atlas;
}
//# sourceMappingURL=default-atlas.js.map